<mat-checkbox
  class="galaxy-checkbox"
  [id]="id()"
  [name]="id()"
  [checked]="inputValue()"
  [formControl]="computedFormControl()"
  (change)="writeValue($event.checked)"
>
  @if (computedLabel()) {
    {{ computedLabel() }}
  } @else {
    <ng-content />
  }
</mat-checkbox>
